import React, { useEffect, useState } from "react";
import { useOutletContext, Link } from "react-router-dom";
import { api } from "../lib/api";
import ServiceIcon from "../components/ServiceIcon";
import { Check, ArrowUpRight } from "lucide-react";

export default function ServicesPage() {
  const { content } = useOutletContext() || {};
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="services-page">
      <section className="relative overflow-hidden px-6 pb-16 pt-20 md:pb-24 md:pt-28">
        <div className="absolute inset-0 radial-glow" />
        <div className="relative mx-auto max-w-7xl">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-fuchsia-400">Our services</p>
          <h1 className="mt-4 text-5xl font-bold tracking-tighter text-white md:text-7xl">
            Everything your brand needs <span className="gradient-text">to grow.</span>
          </h1>
          <p className="mt-6 max-w-3xl text-lg text-white/70">
            From identity systems to performance marketing, we combine craft and data to
            deliver work that moves the needle.
          </p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="mx-auto max-w-7xl space-y-6">
          {services.map((s, idx) => (
            <div
              key={s.id}
              className="grid grid-cols-1 gap-8 rounded-3xl border border-white/10 bg-[#131B2F] p-8 md:grid-cols-12 md:p-12"
              data-testid={`service-row-${s.slug}`}
            >
              <div className="md:col-span-4">
                <div className="flex items-center gap-4">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-white/10 bg-white/5">
                    <ServiceIcon name={s.icon} size={28} className="text-fuchsia-400" />
                  </div>
                  <span className="text-xs uppercase tracking-[0.25em] text-white/40">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h2 className="mt-6 text-3xl font-semibold text-white md:text-4xl">{s.title}</h2>
                {s.tagline && <p className="mt-2 text-sm uppercase tracking-[0.2em] text-fuchsia-300">{s.tagline}</p>}
              </div>
              <div className="md:col-span-8">
                <p className="text-base leading-relaxed text-white/70 md:text-lg">{s.description}</p>
                {s.features?.length > 0 && (
                  <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm text-white/80">
                        <Check size={16} className="mt-0.5 text-fuchsia-400" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                )}
                <Link
                  to="/contact"
                  data-testid={`service-cta-${s.slug}`}
                  className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white"
                >
                  Start a project <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
